import { KoButton, KoForm, KoLoader, KoModal, KoNano,  KoToast } from 'packages';
import React, { useEffect, useState } from 'react';
import WorkspaceSettings from './curd';
import { workspaceAPI } from './workspace.service';
import { useNavigate } from 'react-router';
import Templates from './templates';
import { DEFAULT_TEMPLATES } from './templates/constant';
export default function WorkspaceCurd({openSettings, setOpenSettings, currentWorkspace, selectedTemplate, getWorkspace}) {
  const [form] = KoForm.useForm();

  const [assigneeForm] = KoForm.useForm();
  const [isLoading, setLoading ] = useState(false);
  const [isTemplateModal, setTemplateModal] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState();
  const [workspaceObject, setWorkspaceObject] = useState(currentWorkspace);
  let navigate = useNavigate();



  useEffect(() => {
    if (currentWorkspace?.workspaceId) {
      getWorkspacebyIdX(currentWorkspace?.workspaceId);
    }else{
      let temp = selectedTemplate ? selectedTemplate : DEFAULT_TEMPLATES[0];
      setCurrentTemplate(temp);
    }
  }, [currentWorkspace]);




  const getWorkspacebyIdX = (workspaceId) => {
    workspaceAPI.getWorkspaceById(workspaceId).then(
      (data) => {
        setWorkspaceObject(data['project']);
        form.setFieldsValue(data['project']);
        let temp = data['project']?.template?.templateId ? data['project']?.template : DEFAULT_TEMPLATES[0];
        temp['activityTypes'] =data['project']?.template?.activityTypes || DEFAULT_TEMPLATES[0]?.activityTypes;
        setCurrentTemplate(temp);
      },
      (err) => {
      }
    );
  };

  const handleFinish = (values => {
    setLoading(true);
    if (!workspaceObject?.workspaceId) {
      values['workspaceId'] = KoNano('WOS');
    }
    workspaceAPI.createOrUpdateClient(values, workspaceObject?.workspaceId).then(
      (data) => {
        setLoading(false);
        updateWorkflow(values?.workspaceId || workspaceObject?.workspaceId);
        getWorkspace&& getWorkspace();
        setOpenSettings(false);
        KoToast.success(workspaceObject?.workspaceId ? 'Workspace updated successfully' : 'Workspace created successfully');
      },
      (err) => {
        setLoading(false);
      }
    );
  });

  const updateWorkflow = (wosId) => {
    setLoading(true);
    workspaceAPI.updateWorkflow(currentTemplate, currentTemplate?.templateId, wosId).then(
      (data) => {
        setLoading(false);
        getWorkspace&& getWorkspace();
        setOpenSettings(false);
        getWorkspacebyIdX(wosId);
        if (!workspaceObject?.workspaceId) {
          navigate(`/workspace/${wosId}/${currentTemplate?.type?.toLowerCase()}/dashboard`);
        }
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const updatedTemplate = (template) => {
    setCurrentTemplate(template);
  };

  const resetWorkflow = () => {
    setLoading(true);

    const parsedId = parseInt(currentTemplate?.templateId);
    const temp = DEFAULT_TEMPLATES.find(item => item?.templateId === parsedId);

    if (temp) {
      setCurrentTemplate(temp);
    }

    setTimeout(() => {
      setLoading(false);
    }, 50);
  };


  return (
    <>
      <KoModal
        title={workspaceObject?.workspaceId ? 'Update Workspace' : 'Create Workspace'}
        centered
        open={openSettings}
        afterClose={() => {form.resetFields(); assigneeForm.resetFields(); }}
        handleOk={() => { setOpenSettings(false);form.resetFields(); assigneeForm.resetFields();  }}
        onClose={() => { setOpenSettings(false); form.resetFields(); assigneeForm.resetFields(); }}
        width={'95vw'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => {setOpenSettings(false); form.resetFields(); assigneeForm.resetFields(); }} />,
          <KoButton key='create' loading={isLoading} type='primary' label={workspaceObject?.workspaceId ? `Update` : `Create`}
            onClick={() => form.submit()} />
        ]}
      >
        {isLoading && <KoLoader />}
        <WorkspaceSettings form={form}
          initialValues={workspaceObject}
          getWorkspace={getWorkspace}
          assigneeForm={assigneeForm}
          template={currentTemplate?.workflow}
          templateData={currentTemplate}
          setTemplateModal={() => setTemplateModal(true)}
          resetWorkflow={resetWorkflow}
          updateWorkflowRows={updatedTemplate}
          handleFinish={handleFinish} />
      </KoModal>
      <KoModal
        title={`Project templates`}
        centered
        open={isTemplateModal}
        handleOk={() => { setTemplateModal(false); }}
        onClose={() => { setTemplateModal(false); }}
        width={'95vw'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => {setTemplateModal(false);}} />,
          (!currentTemplate?.isDefault ) && <KoButton key='Submit' type='primary' label='Save Template' onClick={() => {form.submit();}} />,
          <KoButton key='create' disabled={!currentTemplate} loading={isLoading} onClick={() => {setTemplateModal(false);  setOpenSettings(true);}} type='primary' label={'Use Template'} />,
          <KoButton key='request' loading={isLoading} onClick={() => { window.open("https://calendly.com/gokul_r/sync-up-with-gokul", "_blank");}} color='blue' variant='solid' label={'Request for demo'} />

        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <Templates activeTemplate={currentTemplate}  form={form} onSetTemplate={setCurrentTemplate} />
      </KoModal>
    </>
  );
}
